import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from "react-i18next";
import {Box} from "@mui/material";
import ZoneLeaflet from "../../../../../components/ZoneLeaflet";
import {MapArrowIcon} from "../../../../../components/buttons/IconButtons";
import CustomSearch from "../../../../../components/SearchSimples/CustomSearch";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const CafeteriaMap = ({item, handleChange, showOverlay, setShowOverlay, firstClickOnMap}) => {
    const {t} = useTranslation();
    const [searchLocation, setSearchLocation] = useState('');
    const [overlayHiding, setOverlayHiding] = useState(false);
    const timeoutRef = useRef(null);

    const handleMouseEnter = () => {
        overlayAnimation();
    };

    const handleMouseLeave = () => {
        setOverlayHiding(false);
        if(!firstClickOnMap){
            timeoutRef.current = setTimeout(() => {
                setShowOverlay(true);
            }, 300);
        }
    };

    const overlayAnimation = () => {
        setOverlayHiding(true);
        timeoutRef.current = setTimeout(() => {
            setShowOverlay(false);
            setOverlayHiding(false);
        }, 300);
    };

    useEffect(() => {
        return () => clearTimeout(timeoutRef.current);
    }, []);

    return (<>
        <Box className={"col-sm-12 col-md-8 col-lg-8 col-xl-8 offset-md-2 offset-lg-2 offset-xl-2 p-0 d-flex justify-content-center mb-4"}>
            <p className={"ibl-font-w-700"}>{t("choose_location")}</p>
        </Box>
        <Box className={"col-sm-12 col-md-8 col-lg-8 col-xl-8 offset-md-2 offset-lg-2 offset-xl-2 px-0 pt-0 pb-3"}>
            <CustomSearch id={'txt_cm_search'}
                          label={"search_a_place"}
                          value={searchLocation}
                          setValue={setSearchLocation}
                          onChange={(e) => setSearchLocation(e.target.value)}
            />
        </Box>
        <div className="col-sm-12 col-md-8 col-lg-8 col-xl-8 offset-md-2 offset-lg-2 offset-xl-2 px-0 pt-0 pb-3">
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                { (showOverlay) &&
                    <div className={`map-overlay ${overlayHiding ? 'hide-overlay-map' : 'show-overlay-map'}`}>
                        <div className={""}>
                            <div className={"d-flex justify-content-center align-items-center mb-3"}>
                                <span className={"map-arrow"}><MapArrowIcon className="icon-color-general-00"/></span>
                            </div>
                            <p className='legend ibl-font-w-600'>{t('click_location_in_the_map')}</p>
                        </div>
                    </div>
                }
                { item.latitude && item.longitude &&
                    <ZoneLeaflet
                        setLatitude={(value) => handleChange({target:{name:"latitude", value:value}})}
                        setLongitude={(value) => handleChange({target:{name:"longitude", value:value}})}
                        searchLocation={searchLocation}
                        latlng={[item.latitude, item.longitude]}
                        classNameMap={"cafeteria-map-container"}
                    />
                }
            </div>

        </div>
    </>)
}

export default CafeteriaMap;
